import { createContext } from 'react';

interface MainContentClassContextValue {
  setClassName: (className: string) => void;
}

const MainContentClassContext = createContext<MainContentClassContextValue>({
  setClassName: () => {},
});

export default MainContentClassContext;
export type { MainContentClassContextValue };
